import axiosInstance from '../../lib/api/axios';
import { PageParameters } from '../../lib/api/types';
import { getServerUrl } from '../../lib/utils';
import { GetDistinctFieldValuesResponse } from '../entries/types';
import { Table } from '../tables/types';
import { Database } from './types';

export const getDatabases = async (): Promise<Database[]> => {
  const { data } = await axiosInstance.get<Database[]>(`${getServerUrl()}/databases`);
  return data;
};

export const getDatabaseTables = async (databaseSlug: string): Promise<Table[]> => {
  const { data } = await axiosInstance.get(`${getServerUrl()}/databases/${databaseSlug}/tables`);
  return data;
};

export const getDistinctFieldValues = async (
  databaseSlug: string,
  tableSlug: string,
  fieldName: string,
  pageParameters: PageParameters,
  query?: string,
): Promise<GetDistinctFieldValuesResponse> => {
  const { page, perPage } = pageParameters;
  const { data } = await axiosInstance.get(
    `${getServerUrl()}/databases/${databaseSlug}/tables/${tableSlug}/fields/${fieldName}`,
    {
      params: {
        page,
        perPage,
        query,
        removeEmpty: true,
      },
    },
  );
  return data;
};
